import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";

const IconDiscord = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.268 10.07c-.696 0-1.246.593-1.246 1.33 0 .74.562 1.332 1.246 1.332.695 0 1.245-.593 1.245-1.331s-.562-1.331-1.245-1.331zm-4.456 0c-.696 0-1.245.593-1.245 1.33 0 .74.561 1.332 1.245 1.332.696 0 1.245-.593 1.245-1.331.012-.738-.55-1.331-1.245-1.331z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 0H3.842C2.463 0 1.34 1.113 1.34 2.481V18.7c0 1.368 1.123 2.481 2.502 2.481h13.844l-.647-2.215 1.562 1.428 1.477 1.344L22.715 24V2.481A2.514 2.514 0 0020.2 0zm-4.712 15.673s-.44-.52-.805-.968c1.599-.448 2.21-1.428 2.21-1.428a7.01 7.01 0 01-1.405.714 8.806 8.806 0 01-1.77.52 8.622 8.622 0 01-3.162-.012 9.349 9.349 0 01-1.794-.52 7.17 7.17 0 01-.891-.412c-.037-.024-.073-.036-.11-.06-.024-.012-.037-.024-.049-.024-.22-.121-.342-.206-.342-.206s.586.956 2.137 1.416c-.367.46-.818.992-.818.992-2.698-.084-3.723-1.827-3.723-1.827 0-3.861 1.757-6.996 1.757-6.996 1.758-1.295 3.418-1.258 3.418-1.258l.123.145c-2.198.617-3.199 1.573-3.199 1.573s.269-.145.72-.339c1.307-.568 2.344-.714 2.771-.762.074-.012.135-.024.208-.024a10.417 10.417 0 012.466-.025c1.16.134 2.405.472 3.674 1.15 0 0-.964-.907-3.04-1.525l.172-.193s1.672-.037 3.418 1.258c0 0 1.758 3.135 1.758 6.996 0-.012-1.026 1.73-3.724 1.815z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(IconDiscord, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;